// Multi-language translations for PalmPay
// Supports: English, Hindi, Kannada, Tamil, Telugu, Malayalam

export const translations = {
  en: {
    // Navigation
    home: 'Home',
    services: 'Services',
    transfer: 'Transfer',
    history: 'History',
    profile: 'Profile',
    
    // Common
    welcome: 'Welcome back',
    balance: 'Balance',
    send: 'Send',
    receive: 'Receive',
    pay: 'Pay',
    recharge: 'Recharge',
    bills: 'Bills',
    travel: 'Travel',
    financial: 'Financial',
    more: 'More',
    seeAll: 'See All',
    continue: 'Continue',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    success: 'Success',
    failed: 'Failed',
    pending: 'Pending',
    
    // Services
    mobileRecharge: 'Mobile Recharge',
    electricityBill: 'Electricity Bill',
    dthRecharge: 'DTH Recharge',
    broadbandBill: 'Broadband Bill',
    gasBill: 'Gas Bill',
    waterBill: 'Water Bill',
    fastag: 'FASTag',
    insurance: 'Insurance',
    flights: 'Flights',
    hotels: 'Hotels',
    
    // Profile
    palmStatus: 'Palm Status',
    palmRegistered: 'Palm Registered',
    palmNotRegistered: 'Palm Not Registered',
    deviceCenter: 'Device Center',
    limitSettings: 'Limit Settings',
    emergencyLock: 'Emergency Lock',
    
    // Wallet
    addMoney: 'Add Money',
    withdrawMoney: 'Withdraw Money',
    walletBalance: 'Wallet Balance',
    
    // Messages
    paymentSuccessful: 'Payment Successful',
    paymentFailed: 'Payment Failed',
    enterAmount: 'Enter Amount',
    enterMobileNumber: 'Enter Mobile Number',
    selectOperator: 'Select Operator',
    
    // Device
    lastUsed: 'Last used',
    pairDevice: 'Pair Device',
    removeDevice: 'Remove Device',
    deviceStatus: 'Device Status',
  },
  
  hi: {
    // Navigation
    home: 'होम',
    services: 'सेवाएं',
    transfer: 'ट्रांसफर',
    history: 'इतिहास',
    profile: 'प्रोफाइल',
    
    // Common
    welcome: 'वापसी पर स्वागत है',
    balance: 'बैलेंस',
    send: 'भेजें',
    receive: 'प्राप्त करें',
    pay: 'भुगतान करें',
    recharge: 'रिचार्ज',
    bills: 'बिल',
    travel: 'यात्रा',
    financial: 'वित्तीय',
    more: 'अधिक',
    seeAll: 'सभी देखें',
    continue: 'जारी रखें',
    cancel: 'रद्द करें',
    confirm: 'पुष्टि करें',
    back: 'पीछे',
    next: 'आगे',
    submit: 'जमा करें',
    success: 'सफल',
    failed: 'विफल',
    pending: 'लंबित',
    
    // Services
    mobileRecharge: 'मोबाइल रिचार्ज',
    electricityBill: 'बिजली बिल',
    dthRecharge: 'DTH रिचार्ज',
    broadbandBill: 'ब्रॉडबैंड बिल',
    gasBill: 'गैस बिल',
    waterBill: 'पानी का बिल',
    fastag: 'FASTag',
    insurance: 'बीमा',
    flights: 'फ्लाइट्स',
    hotels: 'होटल',
    
    // Profile
    palmStatus: 'पाम स्थिति',
    palmRegistered: 'पाम पंजीकृत',
    palmNotRegistered: 'पाम पंजीकृत नहीं',
    deviceCenter: 'डिवाइस सेंटर',
    limitSettings: 'सीमा सेटिंग्स',
    emergencyLock: 'आपातकालीन लॉक',
    
    // Wallet
    addMoney: 'पैसे जोड़ें',
    withdrawMoney: 'पैसे निकालें',
    walletBalance: 'वॉलेट बैलेंस',
    
    // Messages
    paymentSuccessful: 'भुगतान सफल',
    paymentFailed: 'भुगतान विफल',
    enterAmount: 'राशि दर्ज करें',
    enterMobileNumber: 'मोबाइल नंबर दर्ज करें',
    selectOperator: 'ऑपरेटर चुनें',
    
    // Device
    lastUsed: 'आखिरी बार इस्तेमाल',
    pairDevice: 'डिवाइस जोड़ें',
    removeDevice: 'डिवाइस हटाएं',
    deviceStatus: 'डिवाइस स्थिति',
  },
  
  kn: {
    // Navigation (Kannada)
    home: 'ಮುಖಪುಟ',
    services: 'ಸೇವೆಗಳು',
    transfer: 'ವರ್ಗಾವಣೆ',
    history: 'ಇತಿಹಾಸ',
    profile: 'ಪ್ರೊಫೈಲ್',
    
    // Common
    welcome: 'ಮರಳಿ ಸ್ವಾಗತ',
    balance: 'ಬ್ಯಾಲೆನ್ಸ್',
    send: 'ಕಳುಹಿಸಿ',
    receive: 'ಸ್ವೀಕರಿಸಿ',
    pay: 'ಪಾವತಿಸಿ',
    recharge: 'ರೀಚಾರ್ಜ್',
    bills: 'ಬಿಲ್‌ಗಳು',
    travel: 'ಪ್ರಯಾಣ',
    financial: 'ಆರ್ಥಿಕ',
    more: 'ಹೆಚ್ಚು',
    seeAll: 'ಎಲ್ಲವನ್ನೂ ನೋಡಿ',
    continue: 'ಮುಂದುವರಿಸಿ',
    cancel: 'ರದ್ದುಗೊಳಿಸಿ',
    confirm: 'ದೃಢೀಕರಿಸಿ',
    back: 'ಹಿಂದೆ',
    next: 'ಮುಂದೆ',
    submit: 'ಸಲ್ಲಿಸಿ',
    
    // Services
    mobileRecharge: 'ಮೊಬೈಲ್ ರೀಚಾರ್ಜ್',
    electricityBill: 'ವಿದ್ಯುತ್ ಬಿಲ್',
    palmStatus: 'ಪಾಮ್ ಸ್ಥಿತಿ',
    palmRegistered: 'ಪಾಮ್ ನೋಂದಾಯಿತ',
    palmNotRegistered: 'ಪಾಮ್ ನೋಂದಾಯಿಸಿಲ್ಲ',
  },
  
  ta: {
    // Navigation (Tamil)
    home: 'முகப்பு',
    services: 'சேவைகள்',
    transfer: 'பரிமாற்றம்',
    history: 'வரலாறு',
    profile: 'சுயவிவரம்',
    
    // Common
    welcome: 'மீண்டும் வரவேற்கிறோம்',
    balance: 'இருப்பு',
    send: 'அனுப்பு',
    receive: 'பெறு',
    pay: 'செலுத்து',
    recharge: 'ரீசார்ஜ்',
    bills: 'பில்கள்',
    travel: 'பயணம்',
    financial: 'நிதி',
    more: 'மேலும்',
    seeAll: 'அனைத்தையும் காண்க',
    
    // Services
    mobileRecharge: 'மொபைல் ரீசார்ஜ்',
    electricityBill: 'மின்சாரம் பில்',
    palmStatus: 'பாம் நிலை',
    palmRegistered: 'பாம் பதிவு செய்யப்பட்டது',
    palmNotRegistered: 'பாம் பதிவு செய்யப்படவில்லை',
  },
  
  te: {
    // Navigation (Telugu)
    home: 'హోమ్',
    services: 'సేవలు',
    transfer: 'బదిలీ',
    history: 'చరిత్ర',
    profile: 'ప్రొఫైల్',
    
    // Common
    welcome: 'తిరిగి స్వాగతం',
    balance: 'బ్యాలెన్స్',
    send: 'పంపండి',
    receive: 'స్వీకరించండి',
    pay: 'చెల్లించండి',
    recharge: 'రీచార్జ్',
    bills: 'బిల్లులు',
    
    // Services
    mobileRecharge: 'మొబైల్ రీచార్జ్',
    electricityBill: 'విద్యుత్ బిల్లు',
    palmStatus: 'పామ్ స్థితి',
    palmRegistered: 'పామ్ నమోదు చేయబడింది',
    palmNotRegistered: 'పామ్ నమోదు కాలేదు',
  },
  
  ml: {
    // Navigation (Malayalam)
    home: 'ഹോം',
    services: 'സേവനങ്ങൾ',
    transfer: 'കൈമാറ്റം',
    history: 'ചരിത്രം',
    profile: 'പ്രൊഫൈൽ',
    
    // Common
    welcome: 'തിരിച്ചു വന്നതിൽ സന്തോഷം',
    balance: 'ബാലൻസ്',
    send: 'അയയ്ക്കുക',
    receive: 'സ്വീകരിക്കുക',
    pay: 'അടയ്ക്കുക',
    recharge: 'റീചാർജ്',
    bills: 'ബില്ലുകൾ',
    
    // Services
    mobileRecharge: 'മൊബൈൽ റീചാർജ്',
    electricityBill: 'വൈദ്യുതി ബിൽ',
    palmStatus: 'പാം സ്ഥിതി',
    palmRegistered: 'പാം രജിസ്റ്റർ ചെയ്തു',
    palmNotRegistered: 'പാം രജിസ്റ്റർ ചെയ്തിട്ടില്ല',
  },
  
  bn: {
    // Navigation (Bengali)
    home: 'হোম',
    services: 'সেবা',
    transfer: 'স্থানান্তর',
    history: 'ইতিহাস',
    profile: 'প্রোফাইল',
    welcome: 'ফিরে আসায় স্বাগতম',
    balance: 'ব্যালেন্স',
    send: 'পাঠান',
    pay: 'পরিশোধ করুন',
    mobileRecharge: 'মোবাইল রিচার্জ',
    palmStatus: 'পাম স্ট্যাটাস',
  },
  
  mr: {
    // Navigation (Marathi)
    home: 'मुख्यपृष्ठ',
    services: 'सेवा',
    transfer: 'हस्तांतरण',
    history: 'इतिहास',
    profile: 'प्रोफाइल',
    welcome: 'परत आपले स्वागत आहे',
    balance: 'शिल्लक',
    send: 'पाठवा',
    pay: 'भरा',
    mobileRecharge: 'मोबाइल रिचार्ज',
    palmStatus: 'पाम स्थिती',
  },
  
  gu: {
    // Navigation (Gujarati)
    home: 'હોમ',
    services: 'સેવાઓ',
    transfer: 'ટ્રાન્સફર',
    history: 'ઇતિહાસ',
    profile: 'પ્રોફાઇલ',
    welcome: 'પાછા આવ્યા છો',
    balance: 'બેલેન્સ',
    send: 'મોકલો',
    pay: 'ચૂકવણી',
    mobileRecharge: 'મોબાઇલ રિચાર્જ',
    palmStatus: 'પામ સ્થિતિ',
  },
  
  pa: {
    // Navigation (Punjabi)
    home: 'ਘਰ',
    services: 'ਸੇਵਾਵਾਂ',
    transfer: 'ਟਰਾਂਸਫਰ',
    history: 'ਇਤਿਹਾਸ',
    profile: 'ਪ੍ਰੋਫਾਈਲ',
    welcome: 'ਵਾਪਸ ਆਉਣ ਲਈ ਧੰਨਵਾਦ',
    balance: 'ਬਕਾਇਆ',
    send: 'ਭੇਜੋ',
    pay: 'ਭੁਗਤਾਨ',
    mobileRecharge: 'ਮੋਬਾਈਲ ਰੀਚਾਰਜ',
    palmStatus: 'ਪਾਮ ਸਥਿਤੀ',
  },
  
  ur: {
    // Navigation (Urdu - RTL)
    home: 'ہوم',
    services: 'خدمات',
    transfer: 'منتقلی',
    history: 'تاریخ',
    profile: 'پروفائل',
    welcome: 'واپس آئے',
    balance: 'بیلنس',
    send: 'بھیجیں',
    pay: 'ادائیگی',
    mobileRecharge: 'موبائل ریچارج',
    palmStatus: 'پام حالت',
  }
};

export const languages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिंदी' },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்' },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు' },
  { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം' },
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা' },
  { code: 'mr', name: 'Marathi', nativeName: 'मराठी' },
  { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી' },
  { code: 'pa', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ' },
  { code: 'ur', name: 'Urdu', nativeName: 'اردو' },
];
